import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';
import { COLORS } from '../../../utils/analysis';

const OverviewTab = ({ analysis }) => {
    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Distribuzione Tipi di Risultati</h2>
            <ResponsiveContainer width="100%" height={400}>
                <PieChart>
                    <Pie
                        data={analysis.resultTypes}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, value }) => `${name}: ${value}`}
                        outerRadius={120}
                        fill="#8884d8"
                        dataKey="value"
                    >
                        {analysis.resultTypes.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                </PieChart>
            </ResponsiveContainer>

            {analysis.refinementChips.length > 0 && (
                <div className="mt-6">
                    <h3 className="font-semibold mb-3">Filtri di Ricerca Suggeriti</h3>
                    <div className="flex flex-wrap gap-2">
                        {analysis.refinementChips.map((chip, i) => (
                            <span key={i} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                                {chip}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default OverviewTab;
